import { AfterViewInit, Component, DestroyRef, effect, ElementRef, Inject, inject, OnInit, signal, TemplateRef, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ShellMessageService } from './shared/services/message.service';

/* MSAL */
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType, InteractionStatus, RedirectRequest, SilentRequest } from '@azure/msal-browser';
import { Subject, } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { APIUrlConstants } from './shared/constants/api-url-constants';
import { NavigationComponent } from './shared/components/navigation/navigation.component';
import { ProgressbarComponent } from 'ngx-bootstrap/progressbar';
import { FooterComponent } from './shared/components/footer/footer.component';
import { EngagementService } from './core/services/engagement/engagement.service';
import { UserService } from './core/services/user/user.service';
import { environment } from '../environments/environment';

import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-license';
import { DomSanitizer } from '@angular/platform-browser';
import { LibImanageAssistantComponent, LibImanageAssistantService } from 'lib-imanage-assistant';
import { EngagementAssistant } from './shared/models/assistant.model';
import { EngagementV2 } from './shared/models/engagement.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    NavigationComponent,
    ProgressbarComponent,
    RouterOutlet,
    FooterComponent,
    LibImanageAssistantComponent
  ]
})
export class AppComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  private _engagementService = inject(EngagementService);
  private _libService = inject(LibImanageAssistantService);
  private _router = inject(Router);
  private _modalService = inject(BsModalService);
  private _messageService = inject(ShellMessageService);
  private _userService = inject(UserService);
  private _sanitizer = inject(DomSanitizer);

  private readonly _destroying$ = new Subject<void>();

  pageTitle: string = 'iManage Home';
  isShellEdit = false;
  isLinkExistingTeamsSite = false;
  isAccountRequest = false;
  contentheight = 0;
  isMenuActive: boolean = false; // initialized to false
  currentUrl: string = '';
  showMenu = false;
  isEmbed = true;
  modalRef?: BsModalRef;
  count!: number;
  sessionTimeOutInSeconds: number;
  timeoutWarningInSeconds: number;
  countdown: number = 0;
  isIframe = false;
  loginDisplay = false;
  currentEngagementId = this._engagementService.currentEngagementId();
  safeUrl = this._sanitizer.bypassSecurityTrustResourceUrl(`${environment.assistantUrl}?assistant=1&id=${this.currentEngagementId}&type=engagement&name=null&pageSize=500&v=${Math.random()}`)//(`http://localhost:64033/`)////(`http://localhost:52344/`)

  @ViewChild('templateModal', { static: false })
  private templateModal!: TemplateRef<any>;

  //@ViewChild('iframeAssist') iframe!: ElementRef<HTMLIFrameElement>;

  @ViewChild('cmpAssistant', { static: false })
  private cmpAssistant!: LibImanageAssistantComponent;

  getDropDownHideSubscription: any;
  showAssistant: boolean = true;
  loading: boolean = false;
  isMobile!: boolean;

  isFullWidth: boolean = false;
  private authToken!: string;
  accessTokenRequest!: SilentRequest;

  config = {
    isApp: false,
    iBudgetUrl: environment.iBudget,
    iManageUrl: environment.iManageWeb,
    iManageApiUrl: environment.iManageApi,
    eraUrl: environment.eraServer,
    authority: environment.msalConfig.auth.authority,
    clientId: environment.msalConfig.auth.clientId,
    scopes: environment.apiConfig.scopes,
    pkicViewRequestsUrl: environment.pkicViewRequestsUrl,
    teamsUrl: environment.teamsUrl,
    salesforceUrl: 'https://protiviti.my.salesforce.com/',
    salesforceLightningUrl: 'https://protiviti.lightning.force.com/lightning/',
    powerBIUrl: 'https://app.powerbi.com/reportEmbed?reportId=2553d114-6706-499d-ba86-be0c60bd2525&appId=0e0c062d-8665-4834-bae1-c293fd9bbcd4&autoAuth=true&ctid=16532572-d567-4d67-8727-f12f7bb6aed3&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQifQ%3D%3D&filter=iManageTestTable%2FProject_x0020_Code%20eq%20%27',
    drbUrl: 'https://roberthalf.sharepoint.com/sites/PRO-DRB/SiteAssets/Load-DRB.aspx?drbid=',
    token: ''
  }
  engagementAssistant!: EngagementAssistant;

  constructor(private _idle: Idle,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private _authService: MsalService,
    private _msalBroadcastService: MsalBroadcastService) {
    this.sessionTimeOutInSeconds = Number(environment.sessionTimeoutInSeconds);
    this.timeoutWarningInSeconds = Number(environment.timeoutWarningInSeconds);
    this.currentUrl = window.location.href;

    this._idle.setIdle(this.sessionTimeOutInSeconds);
    this._idle.setTimeout(this.timeoutWarningInSeconds);
    this._idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this._idle.onIdleStart.subscribe(() => {
      this.openModal(this.templateModal);
    });

    this._idle.onIdleEnd.subscribe(() => { });


    this._idle.onTimeoutWarning.subscribe((seconds: number) => {
      this.countdown = seconds
      if (seconds = 0) {
        if (window.location.href.indexOf(APIUrlConstants.SHELL_EDIT + '/') != -1) {
          //tiigger save from page
        }
      }
    });

    this._idle.onTimeout.subscribe(() => {
      this.logout();
    });

    effect(() => {
      this.currentEngagementId = this._engagementService.currentEngagementV2()?.id as string;
      if (this._engagementService.currentEngagementV2()) {
        this._libService.currentEngagementId = this.currentEngagementId;
      }
    });
  }

  hideAllDropDown(): void {
    this.showMenu = false;
  }

  showAssistantMenu(): void {
    this.showMenu = !this.showMenu;
    if (this.showMenu) {
      this.showMenu = true;
      this._libService.currentEngagementId = this._engagementService.currentEngagementId();
      console.log('showMenu', this.showMenu);
      this._libService.loadAssistantData.next(true);
      //this.cmpAssistant.engagementAssistant = this.engagementAssistant;
    }
  }

  ngDoCheck() {
    if (window.innerWidth > 815) {
      this.showAssistant = true;
    } else {
      this.showAssistant = false;
      this.showMenu = false;
    }
  }


  ngOnInit() {
    this._authService.handleRedirectObservable().subscribe();
    config({ licenseKey });
    this.reset();
    this._engagementService.isMenuActivatedChange.subscribe((value) => {
      this.isMenuActive = value;
      this.showMenu = false;
      this.showAssistant = false;
    });

    this.getDropDownHideSubscription =
      this._messageService.getDropDownHideSubject$.subscribe(() => {
        this.hideAllDropDown();
      });

    this._engagementService.assistantChange.subscribe((engagement: EngagementV2) => {
      this._libService.currentEngagementId = engagement.id;

      if (this.showMenu) {
        this._libService.loadAssistantData.next(true);
      }
    });

    this._msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.LOGIN_SUCCESS ||
            msg.eventType === EventType.LOGOUT_SUCCESS
        )
      )
      .subscribe((result: EventMessage) => {
        if (this._authService.instance.getAllAccounts().length === 0) {
          window.location.pathname = '/';
        } else {
          this.setLoginDisplay();
        }
      });

    this._msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.accessTokenRequest = {
          scopes: environment.apiConfig.scopes,
          account: this._authService.instance.getAllAccounts()[0],
        };
        this._authService.acquireTokenSilent(this.accessTokenRequest).subscribe({
          next: (response) => {
            this.authToken = response.accessToken;
            this.config.token = response.accessToken;
            this._libService.setAssistantConfig(this.config)
          },
          error: (error) => {
            console.error('Error acquiring token silently', error);
          },
        })
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
      });

    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this._router.url.includes(APIUrlConstants.SHELL_FILTER)) {
          this.isFullWidth = true;
        }
      }
    });

    if (window.screen.width <= 617) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  openModal(template: TemplateRef<any>): void {
    this._idle.clearInterrupts();
    this.modalRef = this._modalService.show(template, {
      class: 'modal-sm',
      backdrop: 'static',
    });
  }

  confirm(): void {
    this._idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    this._idle.watch();
    this.modalRef?.hide();
  }

  decline(): void {
    if (
      window.location.href.indexOf(APIUrlConstants.SHELL_EDIT + '/') != -1 ||
      window.location.href.indexOf(APIUrlConstants.SHELL_LINKEXISTING) != -1 ||
      window.location.href.indexOf('/orderOpportunityForm/') != -1 ||
      window.location.href.indexOf('/clientacceptance/') != -1
    ) {
      this.loading = true;
    }
    this.modalRef?.hide();
    this.logout();
  }

  logoutClick(): void {
    this.loading = true;
    if (
      window.location.href.indexOf(APIUrlConstants.SHELL_EDIT + '/') != -1 ||
      window.location.href.indexOf(APIUrlConstants.SHELL_LINKEXISTING) != -1 ||
      window.location.href.indexOf('/orderOpportunityForm/') != -1 ||
      window.location.href.indexOf('/clientacceptance/') != -1
    ) {
      // this.shellService.callShellSave(true);
      // this.shellService.SaveShellTrigger$.subscribe().unsubscribe();
    }
    this.logout();
  }

  loginRedirect() {
    if (this.msalGuardConfig.authRequest) {
      this._authService.loginRedirect({
        ...this.msalGuardConfig.authRequest,
      } as RedirectRequest);
    } else {
      this._authService.loginRedirect();
    }
  }

  setLoginDisplay(): void {
    this.loginDisplay = this._authService.instance.getAllAccounts().length > 0 ? true : false;
    if (this.loginDisplay) {
      this._userService.loggedIn.set(true);
      this._userService.getCurrentUser();
    }
  }

  checkAndSetActiveAccount() {
    let activeAccount = this._authService.instance.getActiveAccount();

    if (
      !activeAccount &&
      this._authService.instance.getAllAccounts().length > 0
    ) {
      let accounts = this._authService.instance.getAllAccounts();
      this._authService.instance.setActiveAccount(accounts[0]);
    }
  }

  logout(): void {
    this._userService.loggedIn.set(false);
    this._authService.logoutRedirect();
  }

  reset(): void {
    this._idle.watch();
    this.countdown = 0;
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
